import type { FormProps as ReeferFormProps } from '@iheartjane/reefer-hook-form';
import { Form as ReeferForm } from '@iheartjane/reefer-hook-form';
import type { PropsWithChildren } from 'react';

export const ReeferCompatForm = ({
  children,
  name,
  onSubmit,
}: PropsWithChildren<
  Pick<ReeferFormProps, 'name'> & {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onSubmit: (formData: any) => void;
  }
>) => {
  // default id to name, since id is used when referencing the form
  // in other html elements like button form="id"
  const id = name;
  const reeferFormId = `reefer` + id.slice(0, 1).toUpperCase() + id.slice(1);
  const reeferFormName =
    `reefer` + name.slice(0, 1).toUpperCase() + name.slice(1);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleSubmit = (newFormData: any) => {
    onSubmit(newFormData);
  };

  return (
    <ReeferForm id={reeferFormId} name={reeferFormName} onSubmit={handleSubmit}>
      {children}
    </ReeferForm>
  );
};
